import api from './api';
import { EventSourcePolyfill } from 'event-source-polyfill';

class BalanceService {
  private listeners: ((balance: any) => void)[] = [];
  private eventSource: EventSource | null = null;

  async getCurrentBalance() {
    const response = await api.get('/balance');
    return response.data;
  }

  async getBalanceHistory(months: number = 12) {
    const response = await api.get(`/balance/history?months=${months}`);
    return response.data;
  }

  async recalculate() {
    const response = await api.post('/balance/recalculate');
    return response.data;
  }

  // WebSocket connection para actualizaciones en tiempo real
  connectToBalanceUpdates() {
    if (this.eventSource) {
      this.eventSource.close();
    }

    const token = localStorage.getItem('token');
    this.eventSource = new EventSourcePolyfill(`${process.env.REACT_APP_API_URL}/balance/stream`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    this.eventSource.addEventListener('balance.updated', (event: any) => {
      const data = JSON.parse(event.data);
      this.notifyListeners(data.balance);
    });

    this.eventSource.onerror = (error) => {
      console.error('EventSource failed:', error);
      setTimeout(() => this.connectToBalanceUpdates(), 5000);
    };
  }

  disconnect() {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
  }

  subscribe(callback: (balance: any) => void) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(cb => cb !== callback);
    };
  }

  private notifyListeners(balance: any) {
    this.listeners.forEach(callback => callback(balance));
  }
}

export const balanceService = new BalanceService();